<template>
  <div class="modelDialogContainer">
    <el-dialog
      v-dialogDrag
      :visible.sync="isModelDialog"
      :before-close="handleClose"
      class="title"
      width="1000px"
      title="整合模型"
    >
      <div class="buttonTop">
        <div class="leftButton">
          <el-button
            class="btnBgColor"
            size="small"
            type="primary"
            plain
            @click="clearAll"
            >清空</el-button
          >
          <el-button
            class="btnBgColor del"
            size="small"
            type="danger"
            plain
            @click="batchDel"
            >批量删除</el-button
          >
        </div>
        <div class="rightButton">
          <el-button size="medium" @click="handleClose">取消</el-button>
          <el-button
            class="btnBgColor"
            size="medium"
            type="primary"
            @click="jumpClick"
            >整合</el-button
          >
        </div>
      </div>
      <el-table
        ref="multipleTable"
        class="tableMain"
        :data="modelDialogData"
        height="250"
        @selection-change="handleSelectionChange"
        :cell-style="dialogCellStyle"
        :header-cell-style="dialogHeaderStyle"
      >
        <el-table-column
          v-if="modelDialogData.length > 0 ? true : false"
          type="selection"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="文件名称">
          <template slot-scope="{ row }">
            <div style="display: flex;align-items:center;cursor: pointer">
              <img
                :src="nameIcon(row)"
                style="display:inline-block;flex-shrink: 0; margin-right: 6px;"
              />
              <div style="display: inline-block">
                {{ row.fileName }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operDate" align="center" label="添加时间">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click.native.prevent="deleteRow(scope.$index, modelDialogData)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import XtDesignService from '@/commonService/integratedModel-service';
import { openModels } from '@/commonUtils/docPublic';
import { tableRowIcon } from '@/commonUtils/docPublic';
export default {
  data() {
    return {
      selectTableData: [],
    };
  },
  computed: {
    ...mapState({
      isModelDialog: (state) => state.XtDesign.isModelDialog,
      modelDialogData: (state) => state.XtDesign.modelDialogData,
      prjObj: (state) => state.projectMg.prjObj,
    }),
  },
  methods: {
    // 清空按钮事件
    async clearAll() {
      if (this.modelDialogData.length > 0) {
        // 调用后台接口
        this.$confirm('当前操作将移除列表所有数据，是否确认?', '清空', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = this.modelDialogData.map((item) => {
              return item.id;
            });
            const res = await XtDesignService.batchDelete(
              params
            ).catch(() => {});
            if (res.result === '0') {
              this.$store.dispatch('XtDesignModelDialogData', []);
              this.$parent.$parent.$refs.operations.integrationValue = 0;
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
      } else {
        this.$message({
          type: 'warning',
          message: '文件已清空',
        });
      }
    },
    async clearAllModelWithoutHint() {
      if (this.modelDialogData.length > 0) {
            const params = this.modelDialogData.map((item) => {
              return item.id;
            });
            const res = await XtDesignService.batchDelete(
              params
            ).catch(() => {console.error('删除整合模型失败')});
            if (res.result === '0') {
              this.$store.dispatch('XtDesignModelDialogData', []);
              this.$parent.$parent.$refs.operations.integrationValue = 0;
            }
      }
    },
    // 选择事件，得到选中的数据
    handleSelectionChange(data) {
      this.selectTableData = data;
    },
    // 批量删除
    batchDel() {
      const that = this;
      // 拿到选中的数据
      const val = this.selectTableData;
      // 如果选中的数据存在
      if (val.length > 0) {
        this.$confirm('确当前操作将移除列表所选数据，是否确认?', '批量删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = val.map((item) => {
              return item.id;
            });
            let res = await XtDesignService.batchDelete(params).catch(() => {});
            if (res.result === '0') {
              that.$parent.$parent.$refs.operations.ws();
              const prjId = val[0].prjId;
              await XtDesignService.getQueryList(prjId)
                .then((res) => {
                  if (res.result === '0') {
                    this.$store.dispatch('XtDesignModelDialogData', res.data);
                  }
                })
                .catch((err) => {
                  this.$message.warning(err || '请求出错');
                });
            }
            this.$message({ type: 'success', message: '删除成功!' });
            this.$parent.$parent.$refs.operations.integrationModelNum();
          })
          .catch(() => {
            this.$message({ type: 'info', message: '已取消删除' });
          });
      } else {
        this.$message({ message: '请选择批量删除的文件', type: 'warning' });
      }
      // 清除选中状态
      this.$refs.multipleTable.clearSelection();
    },
    // 删除指定行
    deleteRow(index, rows) {
      this.$confirm('是否确认从列表移除该文件?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await XtDesignService.batchDelete([rows[0].id]);
          if (res.result === '0') {
            this.$parent.$parent.$refs.operations.smallValue =
              this.$parent.$parent.$refs.operations.smallValue - 1;
          }
          this.modelDialogData.splice(index, 1);
          this.$parent.$parent.$refs.operations.integrationModelNum();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 关闭弹窗
    handleClose() {
      this.$store.dispatch('XtDesignIsModelDialog');
    },
    // 整合模型点击跳转事件
    async jumpClick() {
      if (this.selectTableData.length > 0) {
        this.$prompt('请输入整合名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '请输入50字符以内的名称',
          inputPattern: /^\S{1,50}$/,
        })
          .then(async ({ value }) => {
            if (value) {
              const { prjId, prjName } = this.prjObj,
                fileList = this.selectTableData || [],
                params = {
                  fileList,
                  prjId,
                  integrationName: value,
                };
              await XtDesignService.addIntegrationModelLog(params);
              openModels(this.selectTableData, prjId, prjName);
              await this.clearAllModelWithoutHint()
            } else {
              this.$message.info('请输入整合名称');
            }
          })
          .catch((ele) => {
            if (ele == 'cancel') {
              this.$message({ type: 'info', message: '已取消' });
            }
          });
      } else {
        this.$message({
          message: '请勾选文件',
          type: 'warning',
        });
      }
    },

    nameIcon(row) {
      // 因为能够进入整合模型的只有.rvt和.skp两种格式，所以只需根据后缀进行匹配然后根据tableRowIcon传入相对应的fileType值即可
      const reg = /\.(rvt|skp|3dm)$/;
      if (row.fileName.match(reg)[0] === '.rvt') {
        row.fileType = 7;
        return tableRowIcon(row);
      } else {
        row.fileType = 18;
        return tableRowIcon(row);
      }
    },
    dialogCellStyle() {
      return 'padding:6px 0;';
    },
    dialogHeaderStyle() {
      return 'background-color: #F7F9FF;color:#2E384D;height:35px;padding:4px 0;border-top:1px solid #EFF0F9';
    },
  },
  created() {
    // 实现点击进来全选中, toggelRowSelection方法
    this.$nextTick(() => {
      this.modelDialogData.forEach((item) => {
        this.$refs.multipleTable.toggleRowSelection(item, true);
      });
    });
  },
};
</script>
<style lang="stylus" scoped>
.modelDialogContainer {
  .el-picker-panel {
    z-index: 3000 !important;
  }

  .custom-popper {
    z-index: 2500 !important;
  }

  /deep/ .el-dialog__body {
    padding: 20px !important;
  }

  .buttonTop {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .del {
      margin-left: 10px;
    }
  }

  .el-button--primary {
    background: #4777E7;
    border-color: #4777E7;
  }

  .el-button--primary:hover {
    background: #7397EC;
    border-color: #7397EC;
  }

  .el-button--primary.is-plain {
    background: #fff;
    border-color: #4777E7;
    color: #4777E7;
  }

  .el-button--primary.is-plain:hover {
    background: #E1EAFF;
    border-color: #4777E7;
    color: #4777E7;
  }

  .tableMain {
    min-height: 500px;
  }
}
</style>
